import { render, staticRenderFns } from "./SideBarActionItem.vue?vue&type=template&id=44cf2870&scoped=true&"
import script from "./SideBarActionItem.vue?vue&type=script&lang=js&"
export * from "./SideBarActionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cf2870",
  null
  
)

export default component.exports